import classNames from 'classnames';
import React from 'react';
import './Heading.scss';

interface HeadingProps extends React.HTMLProps<HTMLHeadingElement> {
  as?: 'h1' | 'h2' | 'h3' | 'h4';
  level: 1 | 2 | 3 | 4;
  children: React.ReactNode | React.ReactNode[];
  alternative?: boolean;
}

const Heading: React.FC<HeadingProps> = ({
  as = 'h1',
  alternative = false,
  level = 1,
  children,
  className,
  ...rest
}) => {
  return React.createElement(
    as,
    {
      className: classNames(
        'mss-heading',
        {
          'mss-heading--alternative': alternative,
          [`mss-heading-${level}`]: !!level
        },
        className
      ),
      ...rest
    },
    children
  );
};

export default Heading;
